<template>
   <span v-if="status" class="badge status-badge" :class="badgeClass">{{ label }}</span>
</template>

<script>
// Coloured status, e.g. <StatusBadge :status="record.status" :options="statusOptions" />
// options: [{ value: "draft", label: "Draft", color: "secondary" }]  (color = a Bootstrap colour name)
export default {
   name: "StatusBadge",
   props: {
      status: { type: String, default: "" },
      options: { type: Array, default: () => [] },
   },
   computed: {
      option() {
         return this.options.find((o) => o.value === this.status) || null;
      },
      label() {
         return this.option ? this.option.label : this.status;
      },
      badgeClass() {
         const color = this.option?.color || "secondary";
         // Light colours need dark text
         return ["warning", "info", "light"].includes(color) ? `bg-${color} text-dark` : `bg-${color}`;
      },
   },
};
</script>

<style scoped>
.status-badge {
   font-size: 0.75rem;
   font-weight: 600;
   padding: 0.35em 0.6em;
}
</style>